import { AvailableVehicles } from "./AvailableVehicles";

export class VehicleReserves extends AvailableVehicles{
    
}


// WEBPACK FOOTER //
// ./src/app/utilities/Scheduling/VehicleReserves.ts